import {TiptapCollabProviderWebsocket} from '@tiptap-pro/provider';
let socket = null;
export const initCollabSocket = (baseUrl) => {
  if (!socket || socket.status === 'disconnected') {
    const config = baseUrl
      ? {baseUrl}
      : {appId: process.env.REACT_APP_TIPTAP_APP_ID};

    console.log('[collabSocketManager] Initializing socket with:', {
      baseUrl,
      config,
      usingBaseUrl: !!baseUrl,
      usingAppId: !baseUrl,
    });

    socket = new TiptapCollabProviderWebsocket(config);
  }
  return socket;
};

export const getCollabSocket = () => socket;
